import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchPackageCategory } from '@/features/package-categories/api'

import { packageCategoryParamsSchema } from '../-modals'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/package-categories/$packageCategoryId'
)({
  parseParams: (params) => parse(packageCategoryParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, packageCategoryId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      packageCategory: await fetchPackageCategory(
        {
          tenantKey,
          packageCategoryId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.packageCategory.name
    }
  ]
})
